<!--? CONTAINER BTN -->
<button class="container-btn" (click)="navigateToActivity()" [disabled]="false">
    {{'buttons.activity' | translate }}
</button>
